import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g fill="currentColor" key="0"><path d="m21.41 11.58-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42M13 20.01 4 11V4h7v-.01l9 9z" /><path d="M6.5 8C7.3284 8 8 7.3284 8 6.5S7.3284 5 6.5 5 5 5.6716 5 6.5 5.6716 8 6.5 8" /></g>,<defs key="1"></defs>,]
, 'DisplayTagOutlinedx');
